import * as o from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/MonitorArrowUp.es.js";
const r = o.forwardRef((t, e) => /* @__PURE__ */ o.createElement(n, { ref: e, ...t, weights: a }));
r.displayName = "MonitorArrowUpIcon";
const p = r;
export {
  p as MonitorArrowUp,
  r as MonitorArrowUpIcon
};
